import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { Redirect, Link } from 'react-router-dom'
import { Card, Icon, Tooltip } from 'antd'
import { fetchUserInfo, requestAssetAccess } from '../../redux-flow/actions/users'
import { loadContratos, loadContrato, resetContratoForm } from '../../redux-flow/actions/contratos';
import Navbar from '../../Components/Navbar'
import ContratoWrapper from './ContratoWrapper'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import CookieConsentComponent from '../../Components/CookieConsent'
import InsideMenu from '../../Components/InsideMenu'
import SideBar from '../../Components/SideBar'

// import './minhaConta.css'
// import modeloContrato from '../../images/modelo-contrato.pdf'

const NovoContratoBtn = () => (
    <div className="novoContrato mt-3">
        <Link to="/contratos">
            <button type="button" className="btnGrafico">
                Novo Investimento
            </button>
        </Link>
    </div>
)

const LoadingComponent = () => (
    <div style={{ textAlign: 'center' }}>
        <Icon type="loading" />
    </div>
)

class MeusInvestimentos extends PureComponent {
    constructor(props) {
        super(props)
        this.state = {
            contratoSelected: 0,
            modalSenhaOpened: false,
            modalEnderecoOpened: false,
            modalBetaOpened: false,
            fillBackground: false,
            show: true,
            asaActive: false,
            classIcon: '',
            heightWrapper: '0px',
            tipoContrato: 0
        }
    }

    componentDidMount() {
        const { onLoad, userid } = this.props
        if (onLoad && userid) {
            onLoad(this.props.userid)
        }
        window.scrollTo(0,0);
        window.addEventListener('scroll', this.handleWindowScroll, true)
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleWindowScroll, true)
    }

    handleWindowScroll = () => {
        this.setState({
            fillBackground: window.scrollY > 100
        })
    }

    handleClick = (id, tipoContrato) => () => {
        this.props.onSelectContrato(id)
        this.setState({asaActive: tipoContrato === 6 ? false : true, tipoContrato})
        window.scrollTo(0,0);
        window.addEventListener('scroll', this.handleWindowScroll, true)
    }

    openAsa = () => {
        if(this.state.asaActive) {
            this.setState({
                classIcon: '',
                asaActive: false,
                heightWrapper: '0px',
            })
        } else {
            this.setState({
                classIcon: 'rotateIcon',
                asaActive: true,
                heightWrapper: '300px',
            })
        }
    }

    openModalSenha = () => {
        this.setState({
            modalSenhaOpened: true
        })
    }
    openModalEndereco = () => {
        this.setState({
            modalEnderecoOpened: true
        })
    }

    closeModalSenha = () => {
        this.setState({
            modalSenhaOpened: false
        })
    }
    
    closeModalEndereco = () => {
        this.setState({
            modalEnderecoOpened: false
        })
        window.location.reload()
    }

    handleDismiss = () => {
        this.setState({
            show: false
        })
    }

    render() {
        const {
            logged,
            userLogged,
            contratos,
            contratoInfoLoading,
            contratoInfo,
            onPermissao,
            isLoadingAccess,
            success,
            message,
            userid,
            onLoad
        } = this.props
        let currentStep = ''
        let mensagemStep = ''
        let porcentagem = ''
        let statusContrato = contratos.map((contrato) => contrato.status) 
        let contratoDoc = contratos.map((contrato) => contrato.arquivo)
        const spirit = contratos.filter(spirits => spirits.tipoContrato === 6)
        var asa = contratos.filter(asas => asas.tipoContrato !== 6)
        asa = asa.sort((a, b) => a.duracao - b.duracao)

        // Simplified status check without document verification
        if(statusContrato[0] === 2) {
            currentStep = 3
            mensagemStep = 'Contrato solicitado! Assim que sua solicitação for aprovada, ele será enviado para o seu e-mail. (3/5)'
            porcentagem = '60%'
        }
        if(statusContrato[0] === 3 && contratoDoc == '') {
            currentStep = 4
            mensagemStep = 'Seu contrato foi enviado para o e-mail cadastrado! Por favor confirme os dados, assine e anexe o arquivo no campo indicado. (4/5)'
            porcentagem = '80%'
        }
        if(statusContrato[0] === 3 || statusContrato[0] === 1 || statusContrato[0] === 6 && contratoDoc != '' ){
            currentStep = 5
            mensagemStep = 'Tudo certo! Você pode acompanhar diariamente através da plataforma o andamento do seu investimento (5/5)'
            porcentagem = '100%'
        }
        
        return (
            <>
                <Navbar userLogged={userLogged} loggedArea={true} />
                {!logged ? <Redirect to="/login" /> : (
                    <div>
                        <div className="section minhaContaWrapper">
                            <Container>
                                <Row>
                                    <Col md={12} className="p-0">
                                        <InsideMenu />
                                        {this.state.show == true && currentStep != 5 && mensagemStep && mensagemStep.trim() !== '' ? (
                                            <div class="alert alert-danger alert-dismissible fade show notificacao-status" role="alert">
                                                <button type="button" class="close" data-dismiss="alert" aria-label="Close" onClick={this.handleDismiss}>
                                                    <span aria-hidden="true">&times;</span>
                                                </button>
                                                <p className="mb-0">{mensagemStep}</p>
                                            </div>
                                        ) : '' }
                                        
                                        {currentStep != 5 && mensagemStep && mensagemStep.trim() !== '' ? (
                                            <div className="barraStatus">
                                                <div className={`step-${currentStep}`}>
                                                    <label class={porcentagem == '0%' ? 'tx-purple' : ''}>{porcentagem}</label>
                                                </div>
                                            </div>
                                        ) : ''}
                                    </Col>
                                </Row>
                            </Container>
                        </div>
                        <div className={`section insideSec meuFlow ${contratos.length <= 1 ? 'oneContract' : ''}`}>
                            <Container>
                                <Row id="rowInvestimentos">
                                    <Col md={2} className="colProd p-0">
                                        <SideBar nivelVerificacao={userLogged.nivelVerificacao} tipoContrato={this.state.tipoContrato} asaActive={this.state.asaActive} permissao={userLogged.permissao} asa={asa} spirit={spirit}  handleClick={this.handleClick} />
                                    </Col>
                                    <Col md={10} className="colCont pl-5">
                                        <Card>
                                            {contratoInfoLoading ? <LoadingComponent /> : <ContratoWrapper onLoad={onLoad} isLoading={isLoadingAccess} success={success} message={message} userid={userid} onPermissao={onPermissao} permissao={userLogged.permissao} user={userLogged} contrato={contratoInfo} />}
                                        </Card>
                                    </Col>
                                </Row>
                            </Container>
                        </div>
                    </div>
                )}
                <CookieConsentComponent />
            </>
        )
    }
}

const mapStateToProps = state => ({
    logged: state.login.logged,
    userid: state.login.userid,
    userLoading: state.users.isLoading,
    userLogged: state.users.userLogged,
    contratosLoading: state.contratos.isLoading,
    contratos: state.contratos.contratos,
    contratoInfoLoading: state.contratos.isLoadingContrato,
    contratoInfo: state.contratos.contrato,
    isLoadingAccess: state.users.isLoadingAccess,
    success: state.users.success,
    message: state.users.message
})

const mapDispatchToProps = dispatch => ({
    onLoad: id => {
        dispatch(resetContratoForm())
        dispatch(fetchUserInfo(id))
        dispatch(loadContratos(id, (contratos, callback = () => {}) => {
            const [ contrato = {} ] = contratos || []
            if (Object.keys(contrato)) {
                dispatch(loadContrato(contrato.id))
            }
            callback()
        }))
    },
    onSelectContrato: idContrato => dispatch(loadContrato(idContrato)),
    onPermissao: userid => dispatch(requestAssetAccess(userid))
})

export default connect(mapStateToProps, mapDispatchToProps)(MeusInvestimentos)